module.exports = __webpack_public_path__ + "img/choose-application.04fca4e7.svg";